const Info = () => (
  <svg viewBox='0 0 20 20'>
    <path d='M10 18.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 1 1 0 16.666Zm0-1.666a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334ZM9.166 5.833h1.667V7.5H9.166V5.833Zm0 3.334h1.667v5H9.166v-5Z' />
  </svg>
)

export { Info }
